import React, { Fragment, useContext, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useParams } from 'react-router';

import MastheadDemo from '../components/MastheadDemo/MastheadDemo';
import DemoSteps from '../components/DemoSteps/DemoSteps';
import useAxios from '../utils/hooks/useAxios';
import Disclosure from '../components/Disclosure/Disclosure';
import Footer from '../components/Footer/Footer';

import BankingTypeContext from '../utils/BankingType/context';
import { lobSourceName, lobDemoSplit, defaultMetaDescription } from '../utils/LobLogicModule';

const IFrameVariant = () => {
  // Extracted two params from useParams hook
  const { bankingType, demoRoute } = useParams();
	const { setBankingType } = useContext(BankingTypeContext);
  const sourceName = lobSourceName;
  const demoSplit = lobDemoSplit;
  
  // Appended match props passed from Route to fetch demo data
  const { data, isPending, error } = useAxios(`${process.env.REACT_APP_GCDEV_API_DEMO_DETAIL}${demoRoute}`+sourceName);
  
  /* This is a React Hook that is used to set the Banking Type in the context and hide the header. */
  useEffect(() => {
    setBankingType(bankingType);
    document.querySelector('.header').classList.add('iframe--hide');
  }, [bankingType, setBankingType]);


  return (
    <Fragment>
      { isPending && <div className="show-loader"><img src={`${process.env.PUBLIC_URL}/assets/images/loader-large.gif`} alt="" /></div> }
      { (error || data?.error) && <div className="error"><p>{error || data.error.message}</p></div> }
  
      { (data && !data.error) && <main className={"iframe-demo " + data.type.split(" ")[0].toLowerCase() + " " + data.categories.map(category => category === "merchantservices" ? "merchantservices" : "").join("")} data-pageid={demoRoute}>
        <Helmet>
          <html lang={data.lang + '-US'} />
          <meta name="description" content={`${data.metadata ? data.metadata : defaultMetaDescription}`}/>
          </Helmet>
        <MastheadDemo content={data} pageRoute={demoRoute} />
        <DemoSteps content={data} />
        <Disclosure disclosures={data.disclosures} />
        <Footer footerMap={(demoSplit === '' || demoSplit === '/fc' ? `MAP5849152, ` : demoSplit === '/ml' || demoSplit === '/privatebank' ? `MAP5432664, ` : ``) + data.mapNumber} />
      </main> }
    </Fragment>
  )
}

export default IFrameVariant;